@if (viewStateSupportsLayout() && shouldShowLayoutOptions()) {
    <ng-container>
        <st-list-drop-down
            labelPosition="after"
            [value]="viewStateLayoutValue()"
            [label]="languageSettings?.PSTWebViewLabel"
            [list]="viewStateLayoutOptions()?.Options"
            (valueOutput)="updateLayout($event)" />
    </ng-container>
}

@if (viewStateSupportsSortBy()) {
    <st-list-drop-down
        mobileIcon="sort"
        [disabled]="sortByDisabled()"
        [value]="viewStateSortByValue()"
        [label]="languageSettings?.PSTWebSortByLabel"
        [list]="viewStateSortByOptions().Options"
        (valueOutput)="updateSortBy($event)" />
}

@if (viewStateSupportsSortByOrder()) {
    <button
        mat-icon-button
        [disabled]="viewStateSortDisabled()"
        [matTooltip]="viewStateSortByOrderTitle()"
        (click)="updateSortOrder()">
        <mat-icon class="material-symbols-outlined">{{ selectCurrentSortByOrderIcon() }}</mat-icon>
    </button>
}

@if (newlyAddedItems()?.length > 0) {
    <button
        mat-button
        class="st-wastebin-view-options-button-new-items"
        [matMenuTriggerFor]="newItemsMenu"
        (click)="clickNewItemsBtn()">
        {{ newItemsCountLabel() }}
    </button>
    <mat-menu
        #newItemsMenu="matMenu"
        class="st-wastebin-view-options-button-new-items__menu">
        <ng-template matMenuContent>
            @for (item of newlyAddedItems(); track $index) {
                @switch (item?.Type) {
                    @case (objectTypesEnum.TOPIC) {
                        <st-topic-item
                            small="true"
                            [data]="item"
                            [cardViewType]="cardViewType.SMALL"
                            (topicItemClicked)="openTopic(item)" />
                    }
                    @case (objectTypesEnum.SCRIPT) {
                        <st-story-item
                            small="true"
                            [cardViewType]="cardViewType.SMALL"
                            [data]="item"
                            (itemClicked)="openStory(item, undefined, true)" />
                    }
                    @case (objectTypesEnum.RUNDOWN) {
                        <st-live-card-item
                            small="true"
                            [cardViewType]="cardViewType.SMALL"
                            [data]="item"
                            (rundownCliked)="openRundown(item)" />
                    }
                }
            }
        </ng-template>
    </mat-menu>
}
